// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-bar {
  width: 100%;
  height: 4px;
  background-color: #30F;
  animation: loadingAnimation 2s infinite;
}

@keyframes loadingAnimation {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loading-bar/loading-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AACJ;;AAEA;EACI;IACI,4BAAA;EACN;EAEE;IACI,wBAAA;EAAN;EAGE;IACI,2BAAA;EADN;AACF","sourcesContent":[".loading-bar {\n    width: 100%;\n    height: 4px;\n    background-color: #30F;\n    animation: loadingAnimation 2s infinite;\n}\n\n@keyframes loadingAnimation {\n    0% {\n        transform: translateX(-100%);\n    }\n\n    50% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(100%);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
